import { take, all, fork } from "redux-saga/effects";
import { init } from "../store/appSlice";

import authSagas from "./auth";
import transactionsSaga from "./transactions";
import applicationsSaga from "./applications";
import accountsSaga from "./accounts";
import usersSaga from "./users";
import boardingSaga from "./boarding";
import valuesSaga from "./values";
import customersSaga from "./customers";
import notificationsSaga from "./notifications";
import appSaga from "./app";
import banksSaga from "./banks";
import { CashSaga } from "./cashManagement";
import { CashNotificationsSaga } from "./cashManagementNotifications";
import { CashProvidersSaga } from "./cashManagementProviders";
import { CustomersAddressSaga } from "./customersAddress";
import { CustomersPaymentsProvidersSaga } from "./customersPaymentsProviders";
import { CashManagementProviderCustomerConfigsSaga } from "./cashManagementProviderCustomerConfigs";
import { PaymentsProvidersSaga } from "./paymentsProviders";

export default function* root() {
  yield take(init().type);
  // Wait for rehydrate to get applied to prevent sagas from running with empty store
  yield all([
    fork(authSagas),
    fork(transactionsSaga),
    fork(applicationsSaga),
    fork(accountsSaga),
    fork(usersSaga),
    fork(boardingSaga),
    fork(customersSaga),
    fork(valuesSaga),
    fork(notificationsSaga),
    fork(appSaga),
    fork(banksSaga),
    fork(CashSaga),
    fork(CashNotificationsSaga),
    fork(CashProvidersSaga),
    fork(CashManagementProviderCustomerConfigsSaga),
    fork(CustomersAddressSaga),
    fork(CustomersPaymentsProvidersSaga),
    fork(PaymentsProvidersSaga),
  ]);
}
